"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDayList = void 0;
const getDayList = (days, lastDayLabel = 'Last day') => {
    const dayList = new Array(days).fill(0).map((n, i) => ({
        id: `${i + 1}`,
        name: `${i + 1}`,
    }));
    dayList.push({
        id: '32',
        name: lastDayLabel,
    });
    return dayList;
};
exports.getDayList = getDayList;
//# sourceMappingURL=getDayList.js.map